import {
    Box,
    Chip,
    Grid,
    IconButton,
    Modal,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    Tooltip,
} from "@material-ui/core";
import React, { useState, useEffect } from "react";
import VisibilityIcon from "@material-ui/icons/Visibility";
import stringUtils from "../../utils/stringUtils";
import { Link } from "react-router-dom";
import EmpresaService from "../../services/empresaService";
import ModalUsuarios from "../ModalUsuarios";

const TableUsuarios = (props) => {
    const [abrirModal, setAbrirModal] = useState(false);

    const [rows, setRows] = useState([]);
    const [total, setTotal] = useState(0);
    const [pagina, setPagina] = useState(0);
    const [id, setId] = useState(0);
    const [user, setUser] = useState({});
    const [loading, setLoading] = useState(false);

    useEffect(async () => {
        setRows(props.rows);
    }, [props.id]);
    useEffect(async () => {
        setRows(props.rows);
    }, [props.rows]);
    useEffect(async () => {
        setTotal(props.total);
    }, [props.total]);
    useEffect(async () => {
        setPagina(props.pagina);
    }, [props.pagina]);

    const padding = props.padding ? props.padding : 12;

    const emptyRows = 10 - Math.min(10, rows.length);

    const fecharModal = (e) => {
        setAbrirModal(false);
    };

    return (
        <Paper>
            <Modal
                open={abrirModal}
                onClose={fecharModal}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                <Grid>
                    <ModalUsuarios
                        fecharModal={fecharModal}
                        loading={loading}
                        user={user}
                        id={user.id}
                        buscarUsuarios={props.buscarUsuarios}
                        empresaId={props.empresaId}
                        empresa={props.empresa}
                    />
                </Grid>
            </Modal>
            <TableContainer>
                <Table aria-label="sticky table" sx={{ minHeight: "38rem" }}>
                    <TableHead>
                        <TableRow>
                            <TableCell align="center">
                                <Box color="primaryDark.main">
                                    <b>#Id</b>
                                </Box>
                            </TableCell>
                            <TableCell align="center">
                                <Box color="primaryDark.main">
                                    <b>Nome</b>
                                </Box>
                            </TableCell>
                            <TableCell align="center">
                                <Box color="primaryDark.main">
                                    <b>Email</b>
                                </Box>
                            </TableCell>
                            <TableCell align="center">
                                <Box color="primaryDark.main">
                                    <b>Status</b>
                                </Box>
                            </TableCell>
                            <TableCell align="center">
                                <Box color="primaryDark.main">
                                    <b>Ações</b>
                                </Box>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.map((row) => {
                            return (
                                <TableRow
                                    hover
                                    role="checkbox"
                                    tabIndex={-1}
                                    key={row.id}
                                >
                                    <TableCell
                                        align="center"
                                        style={{ padding: padding }}
                                    >
                                        <Chip size="small" label={row.id} />
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                        style={{ padding: padding }}
                                    >
                                        <Box fontSize={13}>{row.nome}</Box>
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                        style={{ padding: padding }}
                                    >
                                        <Box fontSize={13}>{row.username}</Box>
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                        style={{ padding: padding }}
                                    >
                                        <Box fontSize={13}>
                                            {row.ind_ativo ? (
                                                <Chip
                                                    size="small"
                                                    style={{
                                                        backgroundColor:
                                                            "#6CA76B",
                                                        color: "#FFF",
                                                    }}
                                                    label="Ativo"
                                                />
                                            ) : (
                                                <Chip
                                                    size="small"
                                                    style={{
                                                        backgroundColor:
                                                            "#F44336",
                                                        color: "#FFF",
                                                    }}
                                                    label="Inativo"
                                                />
                                            )}
                                        </Box>
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                        style={{ padding: padding }}
                                    >
                                        <Tooltip title="Visualizar">
                                            <IconButton
                                                // component={Link}
                                                onClick={(e) => {
                                                    setUser(row);
                                                    setAbrirModal(true);
                                                }}
                                                aria-label="visualizar"
                                                size="small"
                                                height={11}
                                                width={11}
                                            >
                                                <VisibilityIcon />
                                            </IconButton>
                                        </Tooltip>
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                        {emptyRows > 0 && (
                            <TableRow style={{ height: 53 * emptyRows }}>
                                <TableCell colSpan={7} />
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[]}
                component="div"
                count={parseInt(total)}
                rowsPerPage={10}
                page={parseInt(pagina)}
                onChangePage={props.handleChangePage}
            />
            {/* MODAL */}
        </Paper>
    );
};

export default TableUsuarios;
